module.exports = __webpack_public_path__ + "assets/img/CP-4.a0fd4103.jpg";